module.exports = __webpack_public_path__ + "static/promo-text-8134fec9472557a5bf1fae00f267a614.svg";